export default {
  'approvers.title': 'Approvers Configuration',

  // Criterion nouns after "by" stay singular (one group / position / area / entity per rule).
  'approvers.types.userGroup.description': 'Global approvers by user group',
  'approvers.types.groupAndPosition.description': 'Global approvers by user group and position',
  'approvers.types.globalUserGroupAndArea.description': 'Global approvers by user group and area',
  'approvers.types.entity.description': 'Global approvers by entity and user',
  'approvers.types.entityAndUserGroup.description': 'Global approvers by entity and user group',
  'approvers.types.entityAndPosition.description': 'Global approvers by entity and position',
  'approvers.types.globalEntityAndArea.description': 'Global approvers by entity and area',
  'approvers.level': 'Approval Level',
  'approvers.dynamicEntity': 'Dynamic Entity',
  'approvers.dynamicEntityField': 'Field',
  'approvers.fieldData': 'Value',
  'approvers.area': 'Area',
  'approvers.entityValue': 'Entity Value',

  'approvers.userGroup.title': 'Manage Global Approvers by User Group',
  'approvers.userGroupPosition.title': 'Manage Global Approvers by User Group and Position',
  'approvers.dynamicEntityUser.title': 'Manage Global Approvers by Entity and User',
  'approvers.dynamicEntityUserGroup.title': 'Manage Global Approvers by Entity and User Group',
  'approvers.dynamicEntityPosition.title': 'Manage Global Approvers by Entity and Position',

  'approvers.globalArea.title': 'Manage Global Approvers by User Group and Area',

  'approvers.entityArea.title': 'Manage Global Approvers by Entity and Area',
};
